import axios from 'axios'
import router from "@/router/index";
import request1 from '@/util/request1' // 星邮最新版springboot项目

import {
  Loading
} from 'element-ui';
window.onload = function () {
  // console.log(jsRoutes) 
  let isHttp = false;
  if (window.location.protocol == "https:") {
    isHttp = true;
  }
  let loadingInstance = Loading.service({
    text: 'Loading......',
    lock: true,
    fullscreen: true,
    background: "rgba(0, 0, 0, 0.8)",
    spinner: "el-icon-loading"
  });
  // if (jsRoutes=='undefined') {
  //   loadingInstance.close()
  // }
  // Add a request interceptor
  axios.interceptors.request.use(config => {
      config.withCredentials = true;
      config.timeout = 30000;
      loadingInstance = Loading.service({
        text: 'Loading.....',
        lock: true,
        fullscreen: true,
        background: "rgba(0, 0, 0, 0.8)",
        spinner: "el-icon-loading"
      });
      return config;
    },
    error => {
      loadingInstance.close();
      if (error.response && error.response.status == 401) {
        
        // todo-login
        var r = '/login';
        console.log('>>>>401>>>>>', r, error)
        // window.location.href = r;
      }
      return Promise.reject(error)
    });
  // Add a response interceptor 
  axios.interceptors.response.use(function (response) {
    // Do something with response data 
    loadingInstance.close();
    return response;
  }, function (error) {
    // Do something with response error 
    //没有登陆重新登陆 
    loadingInstance.close();
    if (error.response && error.response.status == 401) {
      // todo-login
      var r = '/login';
      // window.location.href = r;
      router.push('/')
    }
    return Promise.reject(error);
  });
  // var url = '/auth/ck';
  // axios.get(url, {
  //     timeout: 1000, 
  //     withCredentials: true,
  //   })
  //   .then(function (response) {})
  //   .catch(function (error) {
  //     loadingInstance.close();
  //     if (error.response.status == 401) {
  //       var r = '/login';
  //       window.location.href = r;
  //     } 
  //   });
  axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded;charset=UTF-8";
}
//post 
//withCredentials: 授权证书  否则请求会报错 401  没有权限 
export function post(url, data ) {
  return new Promise((resolve, reject) => {
    request1
      .post(url,
          data
        // withCredentials:true
      )
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}
//get请求  withCredentials: 授权证书  否则请求会报错 401  没有权限 
export function get(url, params) {
  return new Promise((resolve, reject) => {
    request1
      .get(url, {
        params: params,
        withCredentials:true
      })
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}
// var obj = {
//         2:3,
//         3:4,
//         length:2,
//         push:Array.prototype.push // 数组的push方法 会从length属性为2的时候 开始插入 
//       }
//       obj.push(1)
//       obj.push(2)
//       console.log(obj)


// WEBPACK FOOTER //
// ./src/util/request.js